<!-- Title -->
<div class="container-title">

    <!-- Minimizar / expandir — escondido quando a lista está travada fechada: aba do
         orçamento (as seções são do conteúdo) ou prévia aberta sem largura para os três
         painéis. Nos dois casos os cards seguem clicáveis no trilho estreito. -->
    @if (!editDataService.sessionsForcedClosed()) {
        <button
            type="button"
            class="icon-button toggle-sessions-button"
            [raEditTooltip]="{ text: ('document.edit.header.toggleSessions' | translate), position: 'right' }"
            (click)="editDataService.toggleSessionsCollapsed()">
            <ra-icon icon="maximize-3" varColor="currentColor" [size]="20" />
        </button>
    }

    <p class="title-text ra-label-s bold">{{ 'document.edit.sessionsList.sessionsHeading' | translate }}</p>

    <!-- Add section -->
    <button
        type="button"
        class="icon-button add-session-button"
        [class.default-disabled]="loadingCreateSession() || editService.loading() || editDataService.documentIsBlocked()"
        [raEditTooltip]="{ text: ('document.edit.sessionsList.addSession' | translate), position: 'left' }"
        (click)="(!loadingCreateSession() && !editService.loading() && !editDataService.documentIsBlocked()) ? createSession() : null">
        @if (loadingCreateSession()) {
            <ra-loading [size]="'small'" />
        }
        @else {
            <ra-icon icon="add" varColor="currentColor" [size]="20" />
        }
    </button>
</div>

<!-- Barra de checklist (progresso, responsáveis). No modo recolhido vira um % compacto. -->
<checklist-bar />

<!-- Sessions list: com overflow, só os cards rolam; "Adicionar seção" fica fixo no rodapé da coluna -->
<div
    #containerSessions
    class="container-sessions-list"
    [class.sessions-list-overflow]="sessionsListOverflow()">
    <div
        #sessionsScroll
        class="sessions-scroll"
        cdkDropList
        [cdkDropListAutoScrollStep]="8"
        (cdkDropListDropped)="drop($event)">
        @if (editService.loading() && !editDataService.document()) {
            <!-- Carga inicial do documento: skeletons no lugar do spinner -->
            @for (skeleton of sessionSkeletons; track $index) {
                <section-card-skeleton [collapsed]="editDataService.sessionsCollapsed()" />
            }
        } @else {
            @for (section of editDataService.document()?.sessions; track section._id; let i = $index) {
                <div
                    cdkDrag
                    class="drag-session"
                    animate.enter="card-enter"
                    animate.leave="card-leave"
                    [style.--enter-delay]="(i % 12) * 35 + 'ms'">
                    <section-card
                        [section]="section"
                        [step]="checklistSteps().get(section._id) ?? null"
                        [collapsed]="editDataService.sessionsCollapsed()"
                        [disabled]="editDataService.documentIsBlocked()"
                    />
                </div>
            } @empty {
                <!-- Documento sem seções. No rail recolhido sobra só o ícone. -->
                <div class="sessions-empty">
                    <span class="empty-icon">
                        <ra-icon icon="document-normal" varColor="currentColor" [size]="22" />
                    </span>
                    <div class="empty-texts">
                        <p class="ra-label-s bold">{{ 'document.edit.sessionsList.emptyTitle' | translate }}</p>
                        <p class="ra-label-xs content-secondary">{{ 'document.edit.sessionsList.emptyMessage' | translate }}</p>
                    </div>
                    <ra-button
                        class="empty-add"
                        icon="add"
                        [label]="'document.edit.sessionsList.addSession' | translate"
                        [type]="'primary-light'"
                        [loading]="loadingCreateSession()"
                        [disabled]="editService.loading() || editDataService.documentIsBlocked()"
                        (click)="(!loadingCreateSession() && !editService.loading() && !editDataService.documentIsBlocked()) ? createSession() : null"
                    />
                </div>
            }
        }
    </div>
</div>
